import { useEffect, useRef } from 'react';
import { useLocation } from 'react-router-dom';
import { trackingEvent } from '../index';

const UrlChangeTracker = () => {
  const location = useLocation();
  const previousUrlRef = useRef(null);

  useEffect(() => {
    trackingEvent('url_changed', {
      url: window.location.href,
      previous_url: previousUrlRef.current
    });
    previousUrlRef.current = window.location.href;
  }, [location.pathname]);

  return null;
};

export default UrlChangeTracker;
